import type { GetterTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { DeviceState } from "./state";
import type { Device } from "@/interfaces/devices";

export const getters: GetterTree<DeviceState, State> = {
  devices: (state): Device[] => state.devices,
  deviceBySerialNumber:
    (state) =>
    (deviceSerial: string): Device => {
      return state.devices.filter(
        (device) => device.serial_number === deviceSerial,
      )[0];
    },
  deviceById:
    (state) =>
    (deviceId: number): Device => {
      return state.devices.filter((device) => device.id === deviceId)[0];
    },
};

const NS = "devices/";

export const readDevices = (store: Store<State>) =>
  store.getters[`${NS}devices`] as Device[];
export const readDeviceBySerialNumber = (store: Store<State>) =>
  store.getters[`${NS}deviceBySerialNumber`] as (serial: string) => Device;
export const readDeviceById = (store: Store<State>) =>
  store.getters[`${NS}deviceById`] as (id: number) => Device;
